import './Navbar.css';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import xlr8logo from '../../assets/acceleratelogo.png';
import '@fortawesome/fontawesome-free/css/all.min.css';

function Navbar() {
  return (
    <div className="navbar-container">
      <div className="navbar-logo">
        <img src={xlr8logo} alt="Accelerate Logo" />
      </div>
      <nav>
        <NavLink to="/team" className={({ isActive }) => (isActive ? "active" : "")} draggable="false">
          <FontAwesomeIcon icon={faHome} color="#4d4d4e" draggable="false" />
        </NavLink>
      </nav>
    </div>
  );
}

export default Navbar;